import React from 'react'
import { shallow } from "zustand/shallow";
import { Button, Text, Title, Stack, ThemeIcon, UnstyledButton, Box, Flex } from "@mantine/core";
import { IconCheck, IconCircle } from "@tabler/icons-react";

import RideChallengeHeader from "./RideChallengeHeader";
import useAppStore from "@components/Microsite/microsite-store";
import sendActionEvents, { actionIds } from "@components/EntityActionAssociator/sendActionEvents";

export default function PresentAtLocationInstructions() {
  const { setActiveStep, entityInfo } = useAppStore(
    (state) => ({
      setActiveStep: state.setActiveStep,
      entityInfo: state.entityInfo,
    }),
    shallow
  );

  return <div>
    <RideChallengeHeader />
    <Stack mt="xl" gap="md">
      <Title order={3} align="center" c="white"><ThemeIcon radius="xl" size="sm" color="green" mr="2px"><IconCheck strokeWidth={5} size={16} /></ThemeIcon> You're Registered for the<br />2026 Let's Ride Challenge</Title>
      <Text align="center" c="dimmed">To start competing, you'll need to visit a participating dealership to validate your odometer.</Text>
    </Stack>
    <Stack mt="lg" gap="md">
      <Text align="center" fw={600} c="white" size="xl">Are you at a dealership right now?</Text>
      <UnstyledButton onClick={() => setActiveStep("vehicle")}>
        <Box p="6px" style={{
          backgroundColor: "var(--mantine-color-orange-6)",
          borderRadius: "var(--mantine-radius-sm)",
        }}>
          <Flex justify="center" align="center" gap="xs">
            <ThemeIcon radius="xl" size="xs" color="white"><IconCheck strokeWidth={4} size={12} style={{
              color: "var(--mantine-color-orange-6)",
            }} /></ThemeIcon>
            <Text align="center" size="lg" fw={600} c="white">I'm at a dealership now</Text>
          </Flex>
          <Text align="center" c="white">Validate my odometer</Text>
        </Box>
      </UnstyledButton>
      <UnstyledButton onClick={() => {
        window.open("https://h-dletsride.com/offsite-registration", "_blank");
        sendActionEvents({
          action_id: actionIds.RC_VISIT_DEALERSHIP_LATER,
          events: entityInfo?.paid_media_settings?.events || [],
        });
      }}>
        <Box p="6px" style={{
          backgroundColor: "var(--mantine-color-dark-7)",
          borderRadius: "var(--mantine-radius-sm)",
        }}>
          <Flex justify="center" align="center" gap="xs">
            <ThemeIcon radius="xl" size="xs" color="white"></ThemeIcon>
            <Text align="center" size="lg" fw={600} c="white">I'll visit a dealership later</Text>
          </Flex>
          <Text align="center" c="white">I'm registered, I'll validate later</Text>
        </Box>
      </UnstyledButton>
    </Stack>
    <Text align="center" c="dimmed" mt="xl">You're fully registered. You can validate any time at a participating dealership.</Text>
  </div>

  return (
    <div>
      <RideChallengeHeader />
      <Stack mt="xl" gap="md">
        <Text align="center" c="white" fw={600} size="xl">Hey, you're registered, but you're not competing until you visit a dealership and get a validated vin and odometer reading</Text>
        <Text align="center" c="white" fw={600} size="xl">Are you at a dealership?</Text>
        <Button size="lg" onClick={() => setActiveStep("vehicle")}>Yes, I'm here</Button>
        <Button size="lg" variant="light" onClick={() => {
          window.open("https://h-dletsride.com/offsite-registration", "_blank");
        }}>No, I'll finish later</Button>
      </Stack>
    </div>
  )
}
